import { render, staticRenderFns } from "./SponsoredBy.vue?vue&type=template&id=0b48cf38"
import script from "./SponsoredBy.vue?vue&type=script&lang=js"
export * from "./SponsoredBy.vue?vue&type=script&lang=js"
import style0 from "./SponsoredBy.vue?vue&type=style&index=0&id=0b48cf38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports